<main aria-labelledby="taxonomyHeader" class="row mt-4 justify-content-end align-items-center pb-3">
  <div class="col-12 text-center">
    <h1 id="taxonomyHeader"
      class="h2 text-truncate">{{taxonomyTitle ? taxonomyTitle : taxonomyData?.children[0].title}}
    </h1>
  </div>

  <app-preloader *ngIf="!taxonomyData && showLoader" [loaderText]="'Loading Data...'"
    class="w-100 position-fixed preloader-backdrop">
  </app-preloader>


  <section class="container filter p-3 mt-3" aria-labelledby="filterTitle"
    *ngIf="currentConfigObj && !displayFullTaxonomy">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <div class="col-auto p-0">
        <h2 id="filterTitle" class="font-4x">Refer to our curriculum framework </h2>
      </div>
      <div class="col-auto p-0" *ngIf="lastSelectedNode">
        <app-export-publish
          [frontFacing]="'true'"
          [option]="'Taxonomy'"
          [exportPermission]="showExportButton"
          [fullTaxonomy]="displayFullTaxonomy"
          [currentTab]="'exportCurriculam'"
          (exportEvent)="onExportTaxonomy($event)"
          [taxonomyTitle]="taxonomyTitle"
          [taxonomyId]="selectedTaxonomyId"
          [taxonomyData]="taxonomyData"
          [dropdownList]="listOfFormats"
          [isCustomView]="false"
          [isOnlyExport]="true"
          [showIcon]="true">
        </app-export-publish>
      </div>
    </div>

    <div class="col-12 mt-3" *ngIf="!displayFullTaxonomy">
      <app-publish-filters
        [taxonomyData]="taxonomyData"
        [configDataObj]="currentConfigObj"
        [isFilterApplied]="disableSelection"
        [domain]="domain"
        (lastNodeSelectEvent)="onLastNodeSelectEvent($event)">
      </app-publish-filters>
    </div>
  </section>
  <section class="taxonomies-container project-authoring position-relative container"
    aria-labelledby="nodeTitle"
    *ngIf="loadDetailPanel">
    <app-tab
      *ngIf="exportTabEnable"
      [tabItems]="tabItems"
      (tabSelectedEvent)="onTabSelected($event)"
      [currentTab]="selectedTab">
    </app-tab>

    <ng-container *ngIf="selectedTab === 'taxonomy'">
      <div id="{{selectedTab}}" role="tabpanel" aria-labelledby="{{selectedTab.split(' ').join('')}}Tab">
        <div class="col-12 px-1 d-flex mt-4 justify-content-between align-items-center">
          <div class="col-10 p-0">
            <h3 id="nodeTitle" class="font-bold font-5x">{{lastSelectedNode?.display_name}}</h3>
          </div>

          <div class="col-auto p-0">
            <app-tree-tab
              (treeTabSelectedEvent)="onTreeTabSelected($event)"
              [showExport]="false"
              [currentTreeTab]="viewType"
              [canPublicReview]="false"
              [viewLocation]="'frontFacingTaxonomyDetail'"
              [treeTabItems]="treeTabItems">
            </app-tree-tab>
          </div>
        </div>

        <div class="col-12 p-0 mb-4">
          <app-tree-search
            *ngIf="viewType==='detailview' || currentTable !== 'node_type_table'"
            [intializeCondition]="isFirstTime && isSearching"
            #treeSearch
            [showFilter]="true"
            [treeData]="currentConfigObj ? lastSelectedNode : taxonomyData"
            [filterCriteriaList]="filterCriteriaList"
            [location]="viewLocation"
            (searchEvent)="captureSearchEvent($event)"
            (loaderEvent)="setLoaderEvent($event)">
          </app-tree-search>
        </div>

        <ng-container *ngIf="viewType ==='listview'">
          <app-node-list 
            [domain]="domain"
            [selectedNode]="lastSelectedNode"
            [configDataObj]="currentConfigObj"
            [taxonomyId]="taxonomyId"
            [isFilterApplied]="isFilterApplied"
            [searchResultList]="searchResultList"
            [isReset]="isReset"
            [isFeedbackNeeded]="false"
            (loadNodeDetails)="loadNodeDetails($event)">
          </app-node-list>
          <app-tabular-tree-side-pane 
            #tabularTreeSidePaneComponent 
            [viewType]="'list_view'" 
            [selectedNode]="lastSelectedNode"
            [viewLocation]="'frontfacing'"
            [taxonomyData]="taxonomyData"
            [showNavigation]="false">
          </app-tabular-tree-side-pane>
        </ng-container>
        <ng-container *ngIf="viewType ==='detailview'">
          <div class="col-12 pl-0 d-flex mt-2">
            <section id="tree_container_id" class="col-6 px-0 panel-left">
              <!--Taxonomy Tree START -->
              <ng-container *ngIf="taxonomyData">
                <ng-container>
                  <div id="accordion" class="col-12 tree--details px-0">
                    <div>
                      <app-tree *ngIf="taxonomyData"
                        [selectedNodeId]="taxonomyItemId ? taxonomyItemId : taxonomyId"
                        [firstNodeLevel]="firstNodeLevel"
                        [isConfigured]="currentConfigObj ? true : false"
                        [filteredListView]="filteredListView"
                        [treeNodes]="currentConfigObj ? lastSelectedNode?.children : taxonomyData.children"
                        [viewLocation]="'frontfacing'"
                        [showComplaince]="false"
                        [searchText]="searchText"
                        [searchResultList]="searchResultList"
                        [isFilterApplied]="isFilterApplied"
                        [isReset]="isReset">
                      </app-tree>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <app-preloader
                *ngIf="!taxonomyData"
                [loaderText]="'Loading Data..'"
                class="w-100 position-fixed preloader-backdrop">
              </app-preloader>
            </section>

            <section id="right_container_id"
              class="col-6 pt-3 bg-lighter panel-right project-authoring taxonomy-preview ff-accordion"
              *ngIf="taxonomyData">
              <app-item-details
                #itemDetailsComponent
                [selectedNode]="lastSelectedNode"
                [isEditable]="false"
                [viewLocation]="viewLocation"
                [showNodeType]="true"
                [taxonomyData]="taxonomyData"
                [showAssociation]="showAssociation"
                [treeTaxonomyData]="taxonomyData"
                [showAdditionalMetadata]="showAdditionalMetadata"
                [showExemplar]="showExemplar"
                [showDocument]="showDocument"
                [addedAdditionalMetadata]="itemAdditionalMetadata"
                [itemExemplars]="itemExemplars"
                [itemAssets]="itemAssets"
                [itemAssociations]="itemAssociations"
                [canPreview]="true"
                [taxonomyItemId] = "taxonomyItemId"
                [isAdvance] = "isAdvance"
                [showUserFriendlyPage]="showUserFriendlyPage">
              </app-item-details>
            </section>
          </div>
        </ng-container>

        <ng-container>
          <div class="table-view">
            <app-tabular-tree-view
              #tabularView
              [showView]="viewType ==='tableview' && currentTable !== 'node_type_table'"
              [listOfClass]="listOfClass"
              [dynamicClass]="dynamicClass"
              [listOfColumn]="listOfColumn"
              [firstNodeLevel]="firstNodeLevel"
              [showNavigation]="true"
              [searchText]="searchText"
              [filteredListView]="filteredListView"
              [searchResultList]="searchResultList"
              [isConfigured]="currentConfigObj ? true : false"
              [isFilterApplied]="isFilterApplied"
              [isReset]="isReset"
              [showUserFriendlyPage]="showUserFriendlyPage">
            </app-tabular-tree-view>

            <app-node-type-table-view
              #nodeTypeTableView
              [hidden]="viewType !=='tableview' || currentTable !== 'node_type_table'"
              [headerData]="listOfColumn"
              [treeData]="taxonomyData?.children">
            </app-node-type-table-view>
          </div>

        </ng-container>
      </div>
    </ng-container>

    <ng-container>
      <app-export-publish
        [frontFacing]="'true'"
        [option]="'Taxonomy'"
        [exportPermission]="showExportButton"
        [fullTaxonomy]="displayFullTaxonomy"
        [currentTab]="selectedTab"
        (exportEvent)="onExportTaxonomy($event)"
        [taxonomyTitle]="taxonomyTitle"
        [taxonomyId]="selectedTaxonomyId"
        [taxonomyData]="taxonomyData"
        [dropdownList]="listOfFormats"
        [isCustomView]="false"
        [isOnlyExport]="true"
        [showIcon]="configDataObj ? true : false">
      </app-export-publish>
    </ng-container>
  </section>

</main>
